module.exports = __webpack_public_path__ + "img/old_mc_donald.6f32f3d2.png";